import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import { DatePicker } from 'antd';
import moment from 'moment';

// Local Deps
import './RFFDateField.scss';
// This is a highly custom field tightly coupled with CSS use other one
function RFFDateField({
  input,
  meta,

  labelText,
  errorCol,
  label,
  isRequired,
  changeDate,
  disabled,
  // options,
  // mode,
  // defaultValue,
  // ...otherProps,
}) {
  const _OnChange = (value, valueString) => {
    if (changeDate) {
      changeDate(input, valueString);
    } else {
      input.onChange(valueString);
    }
  };

  const _disabledDate = current => current && current < moment().endOf('day');
  return (
    <div className="nf-rff-date-field">
      <Row className="nf-rff-date-field__row">
        {/* <!-- LABEL --> */}
        {label && (
          <Label
            className="nf-rff-date-field__label"
            {...labelText}
            htmlFor={input.name}
          >
            {label}
            {isRequired && (
              <span className="nf-rff-input-field__required">*</span>
            )}
          </Label>
        )}

        {/* <!-- INPUT --> */}
        <DatePicker
          disabledDate={_disabledDate}
          disabled={disabled}
          className="nf-rff-date-field__input"
          value={input.value ? moment(input.value) : null}
          onChange={_OnChange}
        />

        {/* <!-- ERROR -> */}
        {meta.touched &&
          meta.error && (
            <Col {...errorCol}>
              <div className="nf-rff-date-field__error">{meta.error}</div>
            </Col>
          )}
      </Row>
    </div>
  );
}

RFFDateField.defaultProps = {
  label: '',
  labelCol: { md: 7, className: 'small-text' },
  labelText: { className: 'small-text' },
  inputCol: { md: 9, className: 'text-left' },
  errorCol: { md: 3 },
  isRequired: false,
  mode: '',
  defaultValue: [],
  disabled: false,
};

RFFDateField.propTypes = {
  disabled: PropTypes.string,
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  labelText: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  options: PropTypes.array.isRequired,
  mode: PropTypes.string,
  defaultValue: PropTypes.string,
  changeDate: PropTypes.func.isRequired,
};

export default RFFDateField;



// WEBPACK FOOTER //
// ./src/components/form/RFFDateSelect/RFFDateField.jsx